const {
  addDays,
  endOfMonth,
  format,
  isAfter,
  isBefore,
  isSameDay,
  isSameMonth,
  parseISO,
  startOfMonth,
  startOfWeek,
} = require("date-fns");

const API_DATE_FORMAT = "yyyy-MM-dd";
const DISPLAY_DATE_FORMAT = "dd MMM yyyy";

function toDate(value) {
  if (!value) return null;
  if (value instanceof Date) return Number.isNaN(value.getTime()) ? null : value;
  const parsed = parseISO(String(value).slice(0, 10));
  return Number.isNaN(parsed.getTime()) ? null : parsed;
}

function normalizeDateKey(value) {
  const date = toDate(value);
  return date ? format(date, API_DATE_FORMAT) : "";
}

function getCalendarGrid(month, year) {
  const monthIndex = Number(month) - 1;
  const visibleMonth = new Date(Number(year), monthIndex, 1);
  const firstCell = startOfWeek(startOfMonth(visibleMonth), { weekStartsOn: 0 });
  const monthStart = startOfMonth(visibleMonth);
  const monthEnd = endOfMonth(visibleMonth);

  return Array.from({ length: 6 }, (_, weekIndex) =>
    Array.from({ length: 7 }, (_, dayIndex) => {
      const date = addDays(firstCell, weekIndex * 7 + dayIndex);
      return {
        date,
        dateKey: format(date, API_DATE_FORMAT),
        day: date.getDate(),
        isCurrentMonth: isSameMonth(date, visibleMonth),
        isToday: isSameDay(date, new Date()),
        isBeforeMonth: isBefore(date, monthStart),
        isAfterMonth: isAfter(date, monthEnd),
      };
    }),
  );
}

function isDateDisabled(dateValue, options = {}) {
  const date = toDate(dateValue);
  if (!date) return true;
  const minDate = toDate(options.minDate);
  const maxDate = toDate(options.maxDate);
  const disabledWeekdays = new Set(options.disabledWeekdays || []);
  const disabledDates = new Set((options.disabledDates || []).map(normalizeDateKey).filter(Boolean));

  if (minDate && isBefore(date, minDate) && !isSameDay(date, minDate)) return true;
  if (maxDate && isAfter(date, maxDate) && !isSameDay(date, maxDate)) return true;
  if (disabledWeekdays.has(date.getDay())) return true;
  if (disabledDates.has(format(date, API_DATE_FORMAT))) return true;
  return false;
}

function formatDateForDisplay(value) {
  const date = toDate(value);
  return date ? format(date, DISPLAY_DATE_FORMAT) : "";
}

function formatDateForAPI(value) {
  const date = toDate(value);
  return date ? format(date, API_DATE_FORMAT) : "";
}

module.exports = {
  API_DATE_FORMAT,
  DISPLAY_DATE_FORMAT,
  formatDateForAPI,
  formatDateForDisplay,
  getCalendarGrid,
  isDateDisabled,
  normalizeDateKey,
  toDate,
};
